export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/valueStream/index.js